import { RETRIEVE_JOB_ROLES } from '../actions/types';

const initialState = {
    items: [],
    totalItems: 0,
    totalPages: 1,
    currentPage: 1,
};

function jobRoleReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_JOB_ROLES:
            return {
                ...state,
                items: payload.data,
                totalItems: payload.totalItems,
                totalPages: payload.totalPages,
                currentPage: payload.currentPage,
            };

        default:
            return state;
    }
}

export default jobRoleReducer;
